import { makeStyles, theme } from "cdh-data-portal-theme"

export const useStyles = makeStyles()(() => ({
  root: {
    background: theme.colors.globalBackgroundLight,
    borderRadius: 8,
    boxShadow: theme.shadows.medium,
    maxWidth: 860,
  },
  header: {
    padding: "16px 24px",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    gap: 20,
    padding: 24,
  },
  dateRow: {
    display: "flex",
    gap: 24,
  },
  datePicker: {
    flex: 1,
  },
  coverageDuration: {
    marginTop: -8,
  },
  footer: {
    padding: "16px 24px",
  },
}))
